import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { hideSuccessModal } from "actions";

const SuccessModal = () => {
  const dispatch = useDispatch();
  const { show_success_modal, success_modal_message } = useSelector(
    (state) => state.commonState
  );

  useEffect(() => {
    if (show_success_modal) {
      const timer = setTimeout(() => {
        dispatch(hideSuccessModal());
      }, 3000);
      return () => clearTimeout(timer);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show_success_modal]);

  return (
    <Modal
      show={show_success_modal}
      onHide={() => dispatch(hideSuccessModal())}
      size="md"
      aria-labelledby="success-modal-title"
      className="success-modal"
      centered
    >
      <div className="text-center p-4">
        <img src="/assets/images/success-img.svg" alt="Success" />
        <p className="heading-color font-14 font-weight-medium">
          {success_modal_message}
        </p>
      </div>
    </Modal>
  );
};

export default SuccessModal;
